export enum EventTypes {
  Event = 'event',
  RequestData = 'request:data',
  RequestModal = 'request:modal',
  RequestToastr = 'request:toastr',
  RequestConfirm = 'request:confirm',
  RequestUpdate = 'request:update',
  RequestNotification = 'request:notification',
}
